
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto
/// Componente obsoleto

import { Grid, IconButton } from '@mui/material';
import { Visibility } from "@mui/icons-material"
import { gridSizeConst1, gridSizeConst3, gridSizeConst5, SystemParametersEnum } from '@/shared';
import {
  CustomTextFieldNoForm,
  SampleCheckboxNoForm,
} from '@/shared/components/ui';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import { IDataPreventa } from '@/shared/interfaces';
import { useEffect, useState } from 'react';
import { useEquiposAdicionales } from '@/store/erp';
import ModalCuotas from '@/erp/sale/asesor/preventa/shared/component/modal_cuotas/ModalCuotas';

interface IEquipoAdicional {
  nombre: string;
  show: boolean;
  slug: string;
  cantidad?: number;
  cuotas?: number;
}

export type EquipoAdicionalPreventaBooleansProps = {
  preventa: Omit<IDataPreventa, 'prospecto_data'>;
};

const EquipoAdicionalPreventaBooleans: React.FC<
  EquipoAdicionalPreventaBooleansProps
> = ({ preventa }) => {

  const {
    es_router_ac,
    requiere_wifi_6,
    es_android_tv,
    es_ups,
  } = preventa || {};

  const [equiposAdicionales, setEquiposAdicionales] = useState<IEquipoAdicional[] | null>(null);
  const getDataProducto = useEquiposAdicionales((s) => s.getDataProducto);

  useEffect(() => {

    if (preventa) {
      setEquiposAdicionales([
        {
          nombre: 'ROUTER AC',
          show: preventa.es_router_ac ?? false,
          cantidad: preventa.numero_cantidad_router_ac,
          cuotas: preventa.numero_cuotas_router_ac,
          slug: SystemParametersEnum.ROUTER_AC
        },
        {
          nombre: 'WIFI 6',
          show: preventa.requiere_wifi_6 ?? false,
          cantidad: preventa.numero_cantidad_wifi_6,
          cuotas: preventa.numero_cuotas_wifi_6,
          slug: SystemParametersEnum.WIFI_6
        },
        {
          nombre: 'ANDROID TV',
          show: preventa.es_android_tv ?? false,
          cantidad: preventa.numero_cantidad_android_tv,
          cuotas: preventa.numero_cuotas_android_tv,
          slug: SystemParametersEnum.ANDROID_TV
        },
        {
          nombre: 'MINI UPS',
          show: preventa.es_ups ?? false,
          cantidad: preventa.numero_cantidad_ups,
          cuotas: preventa.numero_cuotas_ups,
          slug: SystemParametersEnum.MINI_UPS
        },
      ])
    }

    return () => {

    }
  }, [])

  if (!es_router_ac && !requiere_wifi_6 && !es_ups && !es_android_tv)
    return (
      <>
        <CustomAlertCard
          alertTitle="Equipos Adicionales"
          alertMessage={'No se requiere equipo adicional'}
        />
      </>
    );


  return (
    <>
      <Grid item container xs={12} spacing={2}>

        {
          equiposAdicionales?.filter(e => e.show).map((element, index) => {
            return (
              <Grid
                key={`id-${index}`}
                item container xs={12} spacing={1} alignItems="center">
                <SampleCheckboxNoForm
                  label={element.nombre}
                  defaultValue={es_router_ac}
                  disabled
                  size={gridSizeConst5}
                />
                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Cant.'}
                  defaultValue={element.cantidad}
                  size={gridSizeConst3}
                />
                <CustomTextFieldNoForm
                  disabled={true}
                  label={'Cuotas'}
                  defaultValue={element.cuotas}
                  size={gridSizeConst3}
                />

                <Grid item {...gridSizeConst1}>
                  <IconButton
                    onClick={() => {

                      getDataProducto({
                        slug: element.slug as SystemParametersEnum,
                        cantidad:
                          element.cantidad ?? 0,
                        cuotas: element.cuotas ?? 0,
                      });
                    }}
                  >
                    <Visibility />
                  </IconButton>
                </Grid>
              </Grid>

            )
          })
        }
      </Grid>

      <ModalCuotas />
    </>

  )

};

export default EquipoAdicionalPreventaBooleans;
